import { forwardRef, useLayoutEffect } from "react";
import { useState, useEffect } from "react";
import { HiHome } from "react-icons/hi2"
import { FiChevronDown } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { HiSpeakerphone } from "react-icons/hi";
const studentMenu = [
    {
        title: "Dashboard",
        href: "/dashboard/student/",
        icon: <HiHome className="h-5 w-5" />
    },
    {
        title: "Announcements",
        href: "/dashboard/student/announcements",
        icon: <HiSpeakerphone className="h-5 w-5" />
    }

]
const adminMenu = [
    {
        title: "Dashboard",
        href: "/dashboard/admin/",
        icon: <HiHome className="h-5 w-5" />
    },
    {
        title: "All Students",
        href: "/dashboard/admin/all-students",
        icon: <FaUsers className="h-5 w-5" />
    },
    {
        title: "Announcements",
        href: "/dashboard/admin/announcements",
        icon: <HiSpeakerphone className="h-5 w-5" />
    },


    // {
    //   title: "Posts",
    //   icon: <BsFileEarmarkTextFill className="h-5 w-5" />,
    //   subMenus: [
    //     {
    //       title: "All Posts",
    //       href: "/dashboard/admin/all-posts",
    //       icon: <BsFileEarmarkTextFill className="h-5 w-5" />
    //     },
    //     {
    //       title: "Posts Requests",
    //       href: "/dashboard/admin/post-request",
    //       icon: <BsFileEarmarkPlusFill className="h-5 w-5" />
    //     },
    //     {
    //       title: "rejected Posts",
    //       href: "/dashboard/admin/rejected-posts",
    //       icon: <BsFillFileEarmarkMinusFill className="h-5 w-5" />
    //     },
    //   ]
    // }

]

const SideBar = forwardRef(({ showNav, user }, ref) => {

    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [route, setRoute] = useState(null)
    const location = useLocation();
    useEffect(() => {
        setRoute(location.pathname);
        console.log(route)

    }, [window.location.pathname])


    return (
        <div ref={ref} className="fixed w-56 h-full bg-white z-10  shadow-sm">
            <div className="flex justify-center mt-6 mb-14">
                <picture>
                    {/* <img
                        className="w-32 h-10"
                        src="/images/Dashboard.svg"
                        alt="company logo"
                    /> */}
                </picture>
            </div>
            {/* Side bar for admin */}
            {/* // userRole.includes("/dashboard/admin/") && */}
            {
                <div className="flex flex-col">
                    {user?.role === "ADMIN" && adminMenu.map((item, index) => (
                        <div key={index}>
                            <Link to={item.href ? item.href : ""}  >
                                <div
                                    // route.split("/")[3] == item.href.split("/")[3]
                                    className={`px-3 py-3 mx-3 rounded text-center cursor-pointer mb-3  flex items-center transition-colors ${route?.split("/")[3] == item?.href?.split("/")[3]
                                        ? "bg-blue-100 text-blue-500"
                                        : "text-gray-400 hover:bg-blue-100 hover:text-blue-500"
                                        }`}
                                >
                                    <div className="mr-2">
                                        {item.icon}
                                    </div>
                                    <div>
                                        {item.title}
                                    </div>
                                    {item.subMenus && <div className="flex justify-end" >
                                        <FiChevronDown className={`w-5 h-5 ${subMenuOpen && 'rotate-180'}`} onClick={() => setSubMenuOpen(!subMenuOpen)} />
                                    </div>}
                                </div>
                            </Link>
                            {/* {adminMenu.subMenus && subMenuOpen && (
                                <ul>
                                    {adminMenu.subMenus.map((subMenuItem, idx) => (
                                        <li
                                            key={idx}
                                            className="flex px-5 cursor-pointer text-center text-sm text-gray-900 py-1"
                                        >
                                            {subMenuItem.title}
                                        </li>
                                    ))}
                                </ul>
                            )} */}
                        </div>
                    ))}

                    {
                        user?.role === "STUDENT" &&
                        studentMenu.map((item, index) => (
                            <div key={index}>
                                <Link to={item.href ? item.href : ""}  >
                                    <div
                                        // route.split("/")[3] == item.href.split("/")[3]
                                        className={`px-3 py-3 mx-3 rounded text-center cursor-pointer mb-3  flex items-center transition-colors ${route?.split("/")[3] == item?.href?.split("/")[3]
                                            ? "bg-blue-100 text-blue-500"
                                            : "text-gray-400 hover:bg-blue-100 hover:text-blue-500"
                                            }`}
                                    >
                                        <div className="mr-2">
                                            {item.icon}
                                        </div>
                                        <div>
                                            {item.title}
                                        </div>

                                    </div>
                                </Link>
                            </div>
                        ))
                    }



                </div>
            }
        </div>
    );
});

SideBar.displayName = "SideBar";

export default SideBar;
